<span class="e-badge admit-status-badge" [ngStyle]="badgeStyles">
  {{ label }}
</span>
